import { validate } from '@krugom/validator';
import { TValidationScheme } from '@krugom/validator/dist/types';
import { isFunction } from 'lodash';

const executeQue = async (arg?: any) => {
  const scheme: TValidationScheme = {
    type: 'array',
    required: true,
    itemScheme: {
      type: 'custom',
      validator: (value: any) => isFunction(value),
    },
  };
  const result = validate(arg, scheme);

  if (!result.isValid) return;

  for (const action of arg) {
    await action();
  }
};

export default executeQue;
